function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "car_3");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "car_3"
}, /*#__PURE__*/React.createElement("polyline", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "57.06 33.05 60.49 33.05 60.49 25.01 57.06 25.01"
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 2.43,
  y1: 33.94,
  x2: 7.03,
  y2: 33.94
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 45.41,
  cy: 42.13,
  rx: 3.73,
  ry: 3.85
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 13.89,
  cy: 42.13,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 17.97,
  y1: 42.13,
  x2: 41.68,
  y2: 42.13
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M49.14,42.13h5.5a2.55,2.55,0,0,0,2.42-2.66V20.85A2.83,2.83,0,0,0,54.24,18h-26a3.24,3.24,0,0,0-2.7,1.4l-1.88,2.77L19,29H51.48a1.27,1.27,0,0,0,1.31-1.23V23.42a1.27,1.27,0,0,0-1.31-1.23H23.63"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M19.14,29H5.82a3.4,3.4,0,0,0-3.39,3.4v7c0,1.47,1.47,2.66,3.28,2.66H9.8"
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 45.08,
  y1: 22.19,
  x2: 45.08,
  y2: 29.03
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 33.12,
  y1: 22.19,
  x2: 33.12,
  y2: 29.03
}));

var SvgCar3 = function SvgCar3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car_3.a5735602.svg";
export { ForwardRef as ReactComponent };